export default {
  'get-list': {
    method: 'post',
    url: 'partner/trip/list'
  },
  detail: {
    method: 'get',
    url: 'partner/trip/ID'
  },
  archive: {
    method: 'delete',
    url: '/trip/archive'
  }
}
